import React from 'react';

import SelectFormField from '@components/form-fields/SelectFormField';
import TextInputFormField from '@components/form-fields/TextInputFormField';
import WidgetPaper from '@components/widgets/display-widget/WidgetPaper';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';
import { YES_NO } from '@features/production/proposal/constants';

import { useExpatLovs } from '../hooks';
import { FormValues } from '../types';

import { getIn, useFormikContext } from 'formik';
import { makeStyles } from 'tss-react/mui';

type Props = {
  disabledForm: boolean;
};

const useStyles = makeStyles()(() => ({
  fieldRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, minmax(0, 1fr))',
    gap: 12,
    marginBottom: 12
  },
  fullFieldRow: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: 12,
    marginBottom: 12
  }
}));

const ExpatWidgetAtom: React.FC<Props> = ({ disabledForm }) => {
  const { classes } = useStyles();
  const medicalClassOptions = useExpatLovs();

  const { values, errors, touched, setFieldValue, handleBlur } =
    useFormikContext<FormValues>();

  const expat = (values as any).expatDetails || {};

  const setExpat = (name: string, v: unknown) =>
    setFieldValue(`expatDetails.${name}`, v);

  const err = (field: string) =>
    getIn(touched, `expatDetails.${field}`)
      ? (getIn(errors, `expatDetails.${field}`) as string) || ''
      : '';

  return (
    <WidgetPaper>
      <WidgetSection
        title="Expat Details"
        hasTitleSpecificDesign={false}
        useSeparator={false}
      >
        <div className={classes.fieldRow}>
          <SelectFormField
            name="expatDetails.medicalClassID"
            title="Medical Class*"
            placeholder="Medical Class"
            value={expat?.medicalClassID || ''}
            onBlur={(_, e) => handleBlur(e)}
            error={err('medicalClassID')}
            onChange={(v) => setExpat('medicalClassID', v)}
            disabled={disabledForm}
            selectOptions={medicalClassOptions}
            material
          />

          <SelectFormField
            name="expatDetails.emergency"
            title="Emergency*"
            placeholder="Emergency"
            value={expat?.emergency || ''}
            onBlur={(_, e) => handleBlur(e)}
            error={err('emergency')}
            onChange={(v) => setExpat('emergency', v)}
            disabled={disabledForm}
            selectOptions={YES_NO}
            material
          />

          <SelectFormField
            name="expatDetails.continuity"
            title="Continuity"
            placeholder="Continuity"
            value={expat?.continuity || ''}
            onBlur={(_, e) => handleBlur(e)}
            error={err('continuity')}
            onChange={(v) => setExpat('continuity', v)}
            disabled={disabledForm}
            selectOptions={YES_NO}
            material
          />

          <TextInputFormField
            name="expatDetails.continuityNumber"
            title="Continuity Number"
            placeholder="Continuity Number"
            value={expat?.continuityNumber || ''}
            error={err('continuityNumber')}
            onBlur={(e) => handleBlur(e)}
            onChange={(e) => setExpat('continuityNumber', e.target.value)}
            disabled={disabledForm}
            material
          />
        </div>

        <div className={classes.fullFieldRow}>
          <TextInputFormField
            name="expatDetails.exclusion"
            title="Exclusion"
            placeholder="Exclusion"
            value={expat?.exclusion || ''}
            error={err('exclusion')}
            onBlur={(e) => handleBlur(e)}
            onChange={(e) => setExpat('exclusion', e.target.value)}
            disabled={disabledForm}
            material
          />
        </div>

        <div className={classes.fullFieldRow}>
          <TextInputFormField
            name="expatDetails.remarks"
            title="Remarks"
            placeholder="Remarks"
            value={expat?.remarks || ''}
            error={err('remarks')}
            onBlur={(e) => handleBlur(e)}
            onChange={(e) => setExpat('remarks', e.target.value)}
            disabled={disabledForm}
            material
          />
        </div>
      </WidgetSection>
    </WidgetPaper>
  );
};

export { ExpatWidgetAtom };
